import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    categories: [
      {
        slug: 'feminismo',
        name: 'Feminismo en el aula'
      },
      {
        slug: 'edfisica',
        name: 'Educación Física'
      },
    ],
    articles: [
      {
        title: '“El deporte como un estilo de vida y el rescate del folclore nacional”',
        slug: 'educacion-fisica',
        beforetitle: 'Pedagogía en educación física en la UCSH:',
        undertitle: 'Como profesores promotores de la salud se les define a los profesionales de la carrera de educación física de esta casa de estudios. El enfoque de la institución tiene entre sus objetivos promover la vida saludable y el bienestar común.',
        // img: 'content/entrevista-1.jpg',

        img: 'content/edfisica.jpg',
        category: 'edfisica',
        content: '<div class="wrap"><p> Los egresados de pedagogía en educación física de la Universidad Católica Silva Henríquez (UCSH), cuentan con los conocimientos y habilidades necesarias para trabajar en establecimientos educacionales, municipalidades y en clubes u organizaciones deportivas.</p><p> El doctor en actividad física y ciencias del deporte, miembro del consejo académico nacional de educación física en Chile y director de la Escuela de Educación Física de la UCSH, Luis Valenzuela (58), asegura que la carrera tiene un importante foco en la salud.</p><Imagen src="content/luis-valenzuela.jpg" caption="Luis Valenzuela, Director de la Escuela de Educación Física de la UCSH"></Imagen><p>Valenzuela, quien además fue integrante del staff de Marcelo Bielsa entre 2007 y 2010, sostiene que frecuentemente el concepto de salud es asociado solamente a las condiciones físicas de la persona, y no a las emocionales.</p><p> Al respecto, explica que mientras se encontraba desarrollando un estudio para un doctorado que está haciendo en la Universidad de Coímbra, Portugal, hizo una extensa revisión del concepto de salud, y se percató de cómo diferentes actores iban incorporando aspectos como la afectividad, la emoción y el entorno.</p><p> “Las emociones son importantes”, afirma. “Existen altos índices de suicidio en el país, un aumento de licencias por estrés, jornadas laborales extensas y una sociedad competitiva que no nos permite desarrollarnos”.</p><p> A partir de esta reflexión, Valenzuela considera positivo el proyecto de ley que fija 60 minutos de actividad física diaria en jardines y colegios, y que tiene por objetivo disminuir las cifras de obesidad y sobrepeso en el país. Sin embargo, cree que más que decretar el deporte como una obligación, es necesario generar actividades que llamen la atención de los alumnos.</p><p> “Hay que ver cómo provocar que los estudiantes se enamoren de la actividad física, más que lo vean como una obligación”, agrega. “Es importante que para ellos, cobre sentido el hacer ejercicios”.</p><p> Sumado a lo anterior, cree que es fundamental que los profesores de educación física sean los encargados de implementar el proyecto de ley, y actuar de acuerdo a la infraestructura de los diferentes colegios. “No es lo mismo una escuela que tiene gimnasio, duchas, camarines, a otra que no cuente con estos servicios”, enfatiza.</p><p> Precisa que, “es importante que esta medida se preocupe de conocer los intereses de los niños, para que a ellos les resulte agradable realizar las actividades. De esta forma, no les estaremos haciendo una imposición, sino que les generaremos un cambio en su estilo de vida”.</p><p> En ese sentido, propone que las actividades se relacionen, además, con las expresiones culturales de las personas, dependiendo de la región en la que vivan.</p><p> Para Valenzuela, por otro lado, la educación física no tiene como finalidad bajar los índices de obesidad: “Nosotros colaboramos con eso, porque tenemos más herramientas, pero es responsabilidad de la comunidad”.</p><p> Por su parte, Patricia González (40), coordinadora académica y profesora de la carrera de pedagogía en educación física, desde el 2002, también coincide con Valenzuela respecto a que el gran desafío es lograr que los niños encuentren entretenido hacer ejercicios y lo prefieran por sobre otras actividades.</p><Imagen src="content/patricia-gonzalez.jpg" caption="Patricia González, coordinadora académica y profesora de la carrera de pedagogía en educación física."></Imagen><p> “Lo ideal sería no tener que hacer una ley para que se movieran”, recalca. “No obstante, es importante tenerla”.</p><p> González se encarga de impartir dos cursos: en el primero, enseña danzas nacionales folclóricas, mitos y leyendas, además de juegos tradicionales; y en el segundo se enfoca en expresión motriz.</p><p> “La palabra folclore en súper amplia, pero para nosotros es un agente educativo que va más allá de la parte física, el ritmo o la expresión. Es rescatar nuestra cultura y nuestras raíces”, dice González.</p><p> El gran valor de los estudiantes de la UCSH, de acuerdo a ambos académicos, es la conexión que poseen con la sociedad y su constante preocupación con el entorno. “La misión de esta institución es formar a profesores promotores de la salud y del bien común”, afirma Valenzuela. “Profesores que tengan la capacidad de entender cómo la actividad física se hace parte de su vida”.</p><p> Esto se refleja en una nueva metodología que se está usando para fomentar aún más el rol social de la universidad, que es “Aprendizaje y Servicio”, consistente en realizar voluntariados con grupos de niños, jóvenes o adultos mayores, al término de cada curso, y hacerles rutinas de ejercicios de acuerdo a cada contenido.</p></div>',
        alignment: 'left top',
        share: {
          title: 'Pedagogía en educación física en la UCSH: “El deporte como un estilo de vida y el rescate del folclore nacional”',
          description: 'El enfoque de la institución tiene entre sus objetivos promover la vida saludable y el bienestar común.',
          img: 'content/edfisica.jpg',
        },
        credits: [
          {
            title: 'Textos',
            author: 'Belén Peña L.'
          }
        ],
      },
      {
        title: '“El feminismo aporta a la disciplina”',
        slug: 'paula-riquelme',
        beforetitle: 'Paula Riquelme, profesora de psicología de la UCSH:',
        undertitle: 'Para la psicóloga y académica de la Universidad Católica Silva Henríquez, la formación de profesionales en esta área, debe contemplar la enseñanza de teoría feminista y estudios de género. Tener estos conocimientos, asegura, permitirá una mayor comprensión y reflexión al momento de tratar con pacientes.',
        // img: 'content/entrevista-1.jpg',

        img: 'content/paula-riquelme.jpg',
        category: 'feminismo',
        content: '<div class="wrap"><p> La Escuela de Psicología de la Universidad Católica Silva Henríquez (UCSH), apunta principalmente a formar estudiantes con capacidades profesionales y genéricas, que les permitan tener diferentes miradas, teorías y, sobre todo, analizar su propia práctica, con un fuerte énfasis en lo social y en los Derechos Humanos.</p><p> Paula Riquelme (35), psicóloga y académica de la casa de estudios desde hace cinco años, se encarga de enseñar cursos como Clínica con Pacientes Adultos, Psicología Psicoanalítica y Clínica con Pacientes Mujeres, además de guiar tesis y supervisar prácticas profesionales.</p><p> De acuerdo a su experiencia, asegura que hubo un importante cambio tras el movimiento estudiantil feminista que tuvo lugar este año, a nivel nacional, y en el que también se hicieron parte las alumnas de la universidad.</p><p> A través de instalaciones para generar conciencia y la creación de espacios de diálogo, el estudiantado se sumó a las demandas de educación no sexista, aplicación de protocolos contra el acoso sexual y la violencia de género.</p><p> “Las y los estudiantes, en mis cátedras, comenzaron a tener más ganas de hablar de feminismo y menos de teoría psicoanalítica”, afirma. “Tenían la necesidad de encontrar referentes para entender las situaciones de violencia que vivimos como mujeres en espacios públicos o académicos”.</p><p> Para Riquelme, antes del movimiento, la discusión en torno al feminismo en la UCSH no se había generado en profundidad, pese a que sí había dirigido tesis relacionadas con temas de género. “Estar hablando ahora de esto, tiene que ver con el cambio que hubo. Las estudiantes volvieron a posicionar hablar de feminismo o, mejor dicho, de feminismos, porque son muchos”.</p><p> Enfatiza además que, “claramente hay un antes y un después, en términos de pensar qué enseña una como profesora o profesor. Tenemos que estar a la altura de sus demandas”.</p><p> Riquelme analiza también el lugar que tienen los colectivos, cuando las mujeres denuncian episodios de violencia, espacio que asegura que muchas veces prefieren, por sobre acudir a un psicólogo. A partir de este fenómeno, es que considera fundamental poseer todos los conocimientos necesarios. “El feminismo aporta a la disciplina. Es importante que tengamos una formación que implique aprender teoría feminista y de género”, comenta.</p><p> Sostiene que lo anterior, es primordial sobre todo a la hora de escuchar a las pacientes que hayan sido, por ejemplo, víctimas de agresiones sexuales al interior del matrimonio. Esto, a su parecer, les permitirá comprender el lugar que tiene la sociedad en el control del cuerpo, sexualidad y en enfermar a las mujeres.</p><p> “Es necesario que entiendan que una mujer está más expuesta a ser intervenida por la medicina, ya sea en el control de la natalidad, en el ámbito de la ginecología o en su salud mental”, expresa. “Muchas veces el sufrimiento de las mujeres, tiene que ver con sus condiciones de vida y con su precarización”.</p><p> En relación a quienes egresan de psicología de la UCSH, Riquelme precisa que, a diferencia de estudiantes de otras universidades, tienen una mayor sensibilidad con lo social, lo que se percibe en la evaluación de sus casos clínicos y en los temas que eligen para sus tesis, como género, diversidad sexual y el conflicto mapuche. Señala, además, que una parte importante de las y los alumnos se encuentra trabajando en organismos estatales, como el Sename, en el ámbito escolar y en el sector laboral, con trabajadores del sector privado.</p></div>',
        // alignment: 'left top',
        share: {
          title: 'Paula Riquelme, profesora de psicología de la UCSH: “El feminismo aporta a la disciplina”',
          description: 'Tener estos conocimientos, permitirá una mayor comprensión y reflexión al momento de tratar con pacientes.',
          img: 'content/paula-riquelme.jpg',
        },
        credits: [
          {
            title: 'Textos',
            author: 'Belén Peña L.'
          }
        ],
      },
      {
        title: '“El orden de géneros está siendo cuestionado, en cuanto a poder y desigualdad”',
        beforetitle: 'María Eugenia Valenzuela, profesora de sociología de la UCSH:',
        slug: 'maria-eugenia-valenzuela',
        undertitle: 'La socióloga y académica de la Universidad Católica Silva Henríquez, a través de sus cátedras, busca que sus estudiantes tengan la capacidad de problematizar la sociedad, entendiendo las relaciones de género y el concepto de exclusión.',
        img: 'content/maria-eugenia-valenzuela.jpg',
        // img: 'content/entrevista-1.jpg',
        category: 'feminismo',
        // alignment: 'left top',
        content: '<div class="wrap"><p> La carrera de sociología de la Universidad Católica Silva Henríquez (UCSH) busca que las y los estudiantes desarrollen una comprensión de la realidad social chilena y mundial, a través de las transformaciones que experimenta la sociedad. La formación de esta casa de estudios pone énfasis en la importancia del rol social de cada profesional, para influir en ciertas problemáticas.</p><p> María Eugenia Valenzuela (79), académica de sociología de UCSH desde hace ocho años, afirma que quienes ingresan a esta universidad, van adquiriendo un fuerte enfoque social, que se percibe en los trabajos y tesis que realizan con el paso de los años. “Tienen la capacidad de problematizar la sociedad. Eso es parte del ejercicio constante de la escuela”, asegura.</p><p> Uno de los cursos que Valenzuela ha dictado durante sus años haciendo clases en la universidad, es Acción Colectiva, cuyo eje central es estudiar los movimientos sociales. “Es un ramo importantísimo, porque analiza los síntomas y problemas de la sociedad”, explica.</p><p> En relación a aquello, Valenzuela destaca el movimiento feminista estudiantil que tuvo su mayor apogeo este año, a nivel nacional, y que también involucró al estudiantado de la UCSH, quienes se organizaron solicitando respuestas a sus demandas y realizando instalaciones para generar conciencia.</p><p> Diversos hechos son los que han impulsado la llamada “ola feminista” en América Latina, siendo uno de los principales y detonadores de esto, la marcha convocada por “Ni Una Menos”, en 2016, por el femicidio de una menor de edad en Argentina. Los acusados fueron absueltos del delito, en noviembre de este año, en un fallo que ha sido enérgicamente criticado por diversas agrupaciones y la Comisión Interamericana de Mujeres de la OEA.</p><p> “Enseño género desde hace mucho tiempo antes de que apareciera el movimiento estudiantil de este año. El primer curso que di fue Derechos Ciudadanos de la Mujer”, cuenta Valenzuela, para luego explicar que, “me interesa incluir las relaciones de género y que entiendan el concepto de exclusión, sobre todo en una sociedad tan excluyente como la chilena, que crea separaciones físicas y simbólicas”.</p><p> Agrega además que, “en el caso de género, las mujeres están excluidas de ciertas profesiones, de jerarquías administrativas, del poder político y en general, mujeres y hombres, están excluidos de la salud. El concepto de exclusión no es solamente de género, por eso es importante que se enseñe en sociología”.</p><p> Los resultados que ha tenido Valenzuela dictando estos cursos, han sido positivos y, según afirma, ha existido un fuerte crecimiento del interés de sus estudiantes en relación a estos temas. “Hay participación activa en el curso y, en mi experiencia, mujeres y hombres han decidido hacer sus tesis sobre estas problemáticas, como por ejemplo, en relación a la violencia hacia la mujer”.</p><p> “El orden de géneros está siendo cuestionado, en cuanto a poder y desigualdad”, recalca. “Por eso me interesa analizarlo profesionalmente en profundidad. No es la mujer en contra de los hombres, sino en cómo reestructuramos estas relaciones”.</p><p> Para Valenzuela, quienes egresan de sociología en esta institución, se caracterizan por ser profesionales serios y por desempeñarse en importantes trabajos vinculados al gobierno y en organizaciones sociales asociadas a entidades internacionales: “Sobre las alumnas y alumnos a los que les he dirigido la tesis, me llama la atención que han ido ascendiendo y adquiriendo grandes responsabilidades dentro de sus campos laborales. Puedo afirmar, con seguridad, que son profesionales con éxito”.</p></div>',
        share: {
          title: 'María Eugenia Valenzuela, profesora de sociología de la UCSH: “El orden de géneros está siendo cuestionado, en cuanto a poder y desigualdad”',
          description: '',
          img: 'content/maria-eugenia-valenzuela.jpg',
        },
        credits: [
          {
            title: 'Textos',
            author: 'Belén Peña L.'
          }
        ],
      }
    ],
    config: {
      logo: 'assets/images/logos/latercera.svg',
      title: 'Universidad Católica Silva Henríquez',
      url: 'https://www.latercera.com/canal/tendencias',
      papeldigital: true,
      baseurl: 'https://especiales.latercera.com/ucsh',
      description: 'La Universidad',
      hashtag: '#ucsh',
      brandtitle: 'Presentado por la Universidad Católica Silva Henríquez',
      reporttitle: 'Especiales La Tercera',
      jumbo: {
        img: 'content/main.jpg',
        under: '',
      },
      img: 'content/share.jpg',
      slug: '/',
      lab: {
        logo: 'assets/images/logos-white/laboratorio-de-contenidos-de-marca.svg',
        title: 'Laboratorio de Contenidos',
        url: {
          name: "home"
        },
        height: '30'
      },
      brand: {
        logo: 'assets/images/logos-white/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '20'
      },
      sponsor: {
        logo: 'assets/images/logo-ucsh.png',
        title: 'Universidad Católica Silva Henríquez',
        url: {
          name: "home"
        },
        height: '45'
      },
      special: {
        logo: 'assets/images/logo-vision-white.svg',
        title: 'Los distintos sellos de la UCSH',
        url: {
          name: "home"
        },
        height: '40'
      },
      front: {
        logo: 'assets/images/logo-vision-white.svg',
        title: 'Los distintos sellos de la UCSH',
        url: {
          name: "home"
        },
        height: '200'
      },
      site: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '37'
      },
      menu: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '13'
      },
      'papeldata': {
        url: 'https://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
        image: 'https://edition.pagesuite-professional.co.uk/get_image.aspx?w=300&pbid=33084897-397a-48cc-b3c0-3ce1ec447137&pnum=01&nocache=0609201815'
      },
      'navigation': [
        {
          url: 'https://www.latercera.com/',
          name: 'Inicio'
        },
        {
          url: 'https://www.latercera.com/la-tercera-pm/',
          name: 'La Tercera PM'
        },
        {
          url: 'https: //www.latercera.com/canal/pulso/',
          name: 'Pulso'
        },
        {
          url: 'https://www.latercera.com/canal/politica/',
          name: 'Política'
        },
        {
          url: 'https://www.latercera.com/canal/nacional/',
          name: 'Nacional'
        },
        {
          url: 'https://www.latercera.com/canal/mundo/',
          name: 'Mundo'
        },
        {
          url: 'https://www.latercera.com/canal/opinion/',
          name: 'Opinión'
        },
        {
          url: 'https://www.latercera.com/canal/tendencias/',
          name: 'Tendencias'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Cultura'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Entretención'
        },
        {
          url: 'https://www.latercera.com/canal/reportajes/',
          name: 'Reportajes'
        },
        {
          url: 'https://www.latercera.com/canal/el-deportivo/',
          name: 'El Deportivo'
        },
        {
          url: 'https://www.latercera.com/canal/la-tercera-tv/',
          name: 'La Tercera TV'
        },
        {
          url: 'http://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
          name: 'Edición Impresa'
        }
      ],
      'socialnetworks': [
        {
          url: 'https://twitter.com/latercera',
          icon: 'twitter', //TODO, cargar svgs dinámicamente en init
          name: 'Twitter'
        },
        {
          url: 'https://www.facebook.com/laterceracom',
          icon: 'facebook-f', //TODO, cargar svgs dinámicamente en init
          name: 'Facebook'
        },
        {
          url: 'https://flipboard.com/@latercera',
          icon: 'flipboard', //TODO, cargar svgs dinámicamente en init
          name: 'Flipboard'
        },
        {
          url: 'https://www.instagram.com/laterceracom/',
          icon: 'instagram', //TODO, cargar svgs dinámicamente en init
          name: 'Instagram'
        },
        {
          url: 'https://www.youtube.com/user/latercera',
          icon: 'youtube', //TODO, cargar svgs dinámicamente en init
          name: 'Youtube'
        }
      ]
    }
  },
  mutations: {
    SET_LOGO: (state, val) => {
      state.config.logo = val
    }
  },
  actions: {
    setLogo(context, val) {
      context.commit('SET_LOGO', val)
    }
  },
  getters: {
    getArticle: (state) => (slug) => {
      console.log(slug)
      const articlearr = state.articles.filter(i => i.slug === slug)
      console.log(articlearr)
      return articlearr[0]
    },
    getArticleIndex: (state) => (slug) => {
      const articleIndex = state.articles.findIndex(i => i.slug === slug)
      return articleIndex
    },
    getArticlesByCategory: (state) => (category) => {
      console.log(category)
      const articlearr = state.articles.filter(i => i.category === category)
      console.log(articlearr)
      return articlearr
    }
  }
})
